export const TYPES_DEPLACEMENT = [
  { code: "RDV_CL", label: "RDV CLUB", professionnel: true, deplacement: true, couleur: "#1769e0" },
  { code: "RDV_FOUR", label: "FOUR", professionnel: true, deplacement: true, couleur: "#7b4fc9" },
  { code: "TRANS", label: "TRANS", professionnel: true, deplacement: true, couleur: "#057a74" },
  { code: "AUTRE", label: "AUTRE", professionnel: true, deplacement: true, couleur: "#b05b12" },
  { code: "PERSO", label: "PERSO", professionnel: false, deplacement: true, couleur: "#be3455" },
  { code: "SANS_DEPLACEMENT", label: "SANS DÉPLACEMENT", professionnel: false, deplacement: false, couleur: "#65748b" }
];

export const STATUTS_GOOGLE = {
  NON_SYNCHRONISE: "NON SYNCHRONISÉ",
  SYNCHRONISE: "SYNCHRONISÉ",
  MODIFIE: "MODIFIÉ DEPUIS SYNCHRO",
  ERREUR: "ERREUR"
};

const nombre = (valeur) => valeur === "" || valeur == null ? null : Number(valeur);
const texte = (valeur) => String(valeur || "").trim();
const typeInfo = (code) => TYPES_DEPLACEMENT.find((type) => type.code === code) || TYPES_DEPLACEMENT[5];

export function normaliserImmatriculation(valeur) {
  return texte(valeur).toUpperCase().replace(/\s+/g, "");
}

export function validerVehicules(vehicules = []) {
  const erreurs = [];
  const vues = new Set();
  vehicules.forEach((vehicule, index) => {
    const plaque = normaliserImmatriculation(vehicule.immatriculation);
    if (!plaque) erreurs.push({ index, champ: "immatriculation", code: "IMMATRICULATION_OBLIGATOIRE" });
    if (plaque && vues.has(plaque)) erreurs.push({ index, champ: "immatriculation", code: "IMMATRICULATION_DUPLIQUEE" });
    vues.add(plaque);
    if (vehicule.date_debut && vehicule.date_fin && vehicule.date_fin < vehicule.date_debut) erreurs.push({ index, champ: "date_fin", code: "PERIODE_INCOHERENTE" });
  });
  return erreurs;
}

export function vehiculeHabituel(vehicules = [], commercial, date = new Date().toISOString().slice(0, 10)) {
  return vehicules.find((vehicule) => vehicule.actif !== false && texte(vehicule.conducteur_habituel) === texte(commercial)
    && (!vehicule.date_debut || vehicule.date_debut <= date) && (!vehicule.date_fin || vehicule.date_fin >= date)) || null;
}

export function adresseClub(club = {}) {
  return [club.adresse, club.adresse2, [club.code_postal || club.cp, club.ville].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}

export function preparerEvenementDeplacement(evenement = {}, { clubs = [], vehicules = [] } = {}) {
  const avecDeplacement = evenement.avec_deplacement === true || evenement.avec_deplacement === "OUI" || (evenement.avec_deplacement == null && evenement.type_deplacement && evenement.type_deplacement !== "SANS_DEPLACEMENT");
  const type = avecDeplacement ? typeInfo(evenement.type_deplacement) : typeInfo("SANS_DEPLACEMENT");
  const club = clubs.find((item) => String(item.id || item.identifiant) === String(evenement.club_id));
  const vehicule = vehicules.find((item) => String(item.id) === String(evenement.vehicule_id));
  const adresse = texte(evenement.adresse) || (type.code === "RDV_CL" ? adresseClub(club) : "");
  const lieu = texte(evenement.lieu) || (type.code === "RDV_CL" ? texte(club?.nom) : "");
  const erreurs = [];
  if (avecDeplacement && type.code === "TRANS" && !(texte(evenement.depart) && texte(evenement.destination))) erreurs.push("DEPART_DESTINATION_MANQUANTS");
  if (avecDeplacement && type.code !== "TRANS" && !lieu && !adresse) erreurs.push("LIEU_OU_ADRESSE_MANQUANT");
  return { ...evenement, avec_deplacement: avecDeplacement, type_deplacement: type.code, lieu, adresse, immatriculation: normaliserImmatriculation(evenement.immatriculation || vehicule?.immatriculation), est_deplacement: avecDeplacement, professionnel: avecDeplacement && type.professionnel, incomplet: erreurs.length > 0, erreurs };
}

export function empreinteEvenementAgenda(evenement = {}) {
  const donnees = ["date_rdv", "heure_rdv", "heure_fin", "type_deplacement", "objet", "lieu", "adresse", "commercial", "note"]
    .map((cle) => texte(evenement[cle]));
  let hash = 2166136261;
  JSON.stringify(donnees).split("").forEach((caractere) => { hash ^= caractere.charCodeAt(0); hash = Math.imul(hash, 16777619); });
  return (hash >>> 0).toString(16).padStart(8, "0");
}

export function preparerSyncGoogle(evenement, precedent = {}, apiDisponible = false) {
  const empreinte = empreinteEvenementAgenda(evenement);
  if (!apiDisponible) return { action: "BLOQUE", statut: STATUTS_GOOGLE.ERREUR, erreur: "CONNEXION_GOOGLE_INDISPONIBLE", google_event_id: precedent.google_event_id || null, empreinte };
  if (!precedent.google_event_id) return { action: "CREER", statut: STATUTS_GOOGLE.NON_SYNCHRONISE, google_event_id: null, empreinte };
  if (precedent.empreinte_google === empreinte) return { action: "AUCUNE", statut: STATUTS_GOOGLE.SYNCHRONISE, google_event_id: precedent.google_event_id, empreinte };
  return { action: "METTRE_A_JOUR", statut: STATUTS_GOOGLE.MODIFIE, google_event_id: precedent.google_event_id, empreinte };
}

export function selectionSyncPeriode(evenements = [], debut, fin) {
  return evenements.filter((evenement) => evenement.date_rdv >= debut && evenement.date_rdv <= fin);
}

export function lundiIso(dateSource) {
  const date = new Date(`${String(dateSource).slice(0, 10)}T12:00:00`);
  const jour = date.getDay() || 7;
  date.setDate(date.getDate() - jour + 1);
  return date.toISOString().slice(0, 10);
}

export function repriseCompteurPrecedent(releves = [], vehiculeId, semaine) {
  return releves.filter((releve) => String(releve.vehicule_id) === String(vehiculeId) && releve.statut === "VALIDÉ" && releve.semaine < semaine)
    .sort((a, b) => String(b.semaine).localeCompare(String(a.semaine)))[0]?.compteur_fin ?? null;
}

export function calculerReleveHebdomadaire(releve = {}, deplacements = []) {
  const debut = nombre(releve.compteur_debut);
  const fin = nombre(releve.compteur_fin);
  const total = debut == null || fin == null ? null : fin - debut;
  const filtres = deplacements.filter((item) => item.est_deplacement !== false && (!releve.commercial || item.commercial === releve.commercial)
    && (!releve.vehicule_id || String(item.vehicule_id) === String(releve.vehicule_id)) && (!releve.semaine || lundiIso(item.date_rdv) === releve.semaine));
  const kmPro = filtres.filter((item) => item.professionnel === true).reduce((somme, item) => somme + (nombre(item.km_documentes) || 0), 0);
  const kmPerso = filtres.filter((item) => item.type_deplacement === "PERSO" || item.professionnel === false).reduce((somme, item) => somme + (nombre(item.km_documentes) || 0), 0);
  const aJustifier = total == null ? null : Math.max(0, total - kmPro - kmPerso);
  const alertes = [];
  if (!normaliserImmatriculation(releve.immatriculation)) alertes.push("IMMATRICULATION_MANQUANTE");
  if (total != null && total < 0) alertes.push("COMPTEUR_FIN_INFERIEUR");
  if (total != null && kmPro + kmPerso > total) alertes.push("KM_DOCUMENTES_SUPERIEURS_COMPTEUR");
  if (filtres.some((item) => item.incomplet)) alertes.push("DEPLACEMENT_INCOMPLET");
  if (aJustifier > 0) alertes.push("KM_A_JUSTIFIER");
  return { ...releve, compteur_debut: debut, compteur_fin: fin, km_total: total, km_pro: kmPro, km_perso: kmPerso, km_a_justifier: aJustifier, pourcentage_pro: total > 0 ? kmPro / total : 0, pourcentage_perso: total > 0 ? kmPerso / total : 0, deplacements: filtres, alertes };
}

export function verifierContinuite(releve, releves = []) {
  const precedent = repriseCompteurPrecedent(releves, releve.vehicule_id, releve.semaine);
  return precedent == null || Number(releve.compteur_debut) === Number(precedent) ? [] : ["REPRISE_COMPTEUR_INCOHERENTE"];
}

export function detecterChevauchement(releve, releves = []) {
  return releves.some((item) => item.id !== releve.id && item.semaine === releve.semaine && String(item.vehicule_id) === String(releve.vehicule_id)) ? ["RELEVE_CHEVAUCHANT"] : [];
}

export function validerReleveHebdomadaire(releve, deplacements = [], releves = [], auteur = "Utilisateur", date = new Date().toISOString()) {
  const calcul = calculerReleveHebdomadaire(releve, deplacements);
  const erreurs = [...calcul.alertes, ...verifierContinuite(calcul, releves), ...detecterChevauchement(calcul, releves)];
  const statut = erreurs.length ? "À COMPLÉTER" : "VALIDÉ";
  return { ...calcul, statut, erreurs, valide_le: statut === "VALIDÉ" ? date : null, valide_par: statut === "VALIDÉ" ? auteur : null, snapshot: statut === "VALIDÉ" ? JSON.parse(JSON.stringify({ ...calcul, statut, valide_le: date, valide_par: auteur })) : null };
}

export function corrigerReleveValide(releve, changements, auteur, motif, date = new Date().toISOString()) {
  if (releve.statut !== "VALIDÉ") return { ...releve, ...changements };
  if (!texte(motif)) throw new Error("MOTIF_CORRECTION_OBLIGATOIRE");
  const historique = [...(releve.historique_corrections || [])];
  Object.entries(changements).forEach(([champ, nouvelleValeur]) => {
    if (releve[champ] !== nouvelleValeur) historique.push({ date, auteur, motif, champ, ancienne_valeur: releve[champ], nouvelle_valeur: nouvelleValeur });
  });
  return { ...releve, ...changements, statut: "BROUILLON", historique_corrections: historique };
}

export function syntheseReleves(releves = []) {
  const valides = releves.map((releve) => calculerReleveHebdomadaire(releve, releve.deplacements || []));
  const somme = (champ) => valides.reduce((total, releve) => total + (Number(releve[champ]) || 0), 0);
  const kmTotal = somme("km_total");
  return { compteur_debut: valides[0]?.compteur_debut ?? null, compteur_fin: valides.at(-1)?.compteur_fin ?? null, km_total: kmTotal, km_pro: somme("km_pro"), km_perso: somme("km_perso"), km_a_justifier: somme("km_a_justifier"), pourcentage_pro: kmTotal ? somme("km_pro") / kmTotal : 0, pourcentage_perso: kmTotal ? somme("km_perso") / kmTotal : 0 };
}

export function syntheseAnnuelleVehicules(releves = [], vehicules = [], annee) {
  return vehicules.map((vehicule) => {
    const lignes = releves.filter((releve) => String(releve.vehicule_id) === String(vehicule.id) && String(releve.semaine).startsWith(String(annee))).sort((a, b) => a.semaine.localeCompare(b.semaine));
    return { vehicule: `${vehicule.marque || ""} ${vehicule.modele || ""}`.trim(), immatriculation: normaliserImmatriculation(vehicule.immatriculation), conducteurs: Array.from(new Set(lignes.map((ligne) => ligne.commercial).filter(Boolean))), ...syntheseReleves(lignes), releves: lignes };
  });
}

const dateReleveLibre = (releve = {}) => String(releve.date_releve || releve.date || releve.semaine || "").slice(0, 10);
const compteurReleveLibre = (releve = {}) => releve.compteur !== undefined && releve.compteur !== "" ? Number(releve.compteur) : Number(releve.compteur_fin);

// Les anciens relevés hebdomadaires restent lisibles, mais toute nouvelle saisie
// utilise uniquement une date et la valeur réelle du compteur.
export function normaliserRelevesLibres(releves = []) {
  const groupes = new Map();
  releves.forEach((source) => {
    const releve = { ...source, date_releve: dateReleveLibre(source), compteur: compteurReleveLibre(source) };
    const cle = String(releve.vehicule_id || releve.immatriculation || "sans-vehicule");
    if (!groupes.has(cle)) groupes.set(cle, []);
    groupes.get(cle).push(releve);
  });
  const resultat = [];
  groupes.forEach((lignes) => {
    lignes.sort((a, b) => a.date_releve.localeCompare(b.date_releve) || String(a.cree_le || a.id || "").localeCompare(String(b.cree_le || b.id || "")));
    lignes.forEach((ligne, index) => {
      const precedent = lignes[index - 1] || null;
      resultat.push({ ...ligne, compteur_precedent: precedent?.compteur ?? null, date_precedente: precedent?.date_releve || null, km_depuis_precedent: precedent ? ligne.compteur - precedent.compteur : null });
    });
  });
  return resultat.sort((a, b) => b.date_releve.localeCompare(a.date_releve) || String(b.cree_le || b.id || "").localeCompare(String(a.cree_le || a.id || "")));
}

export function validerNouveauReleve(releve, releves = []) {
  const date = dateReleveLibre(releve);
  const compteur = Number(releve.compteur);
  const vehiculeId = String(releve.vehicule_id || "");
  const erreurs = [];
  if (!date) erreurs.push("DATE_OBLIGATOIRE");
  if (!vehiculeId) erreurs.push("VEHICULE_OBLIGATOIRE");
  if (!Number.isFinite(compteur) || compteur < 0) erreurs.push("COMPTEUR_INVALIDE");
  const memes = normaliserRelevesLibres(releves).filter((item) => String(item.vehicule_id) === vehiculeId && String(item.id) !== String(releve.id || ""));
  if (memes.some((item) => item.date_releve === date)) erreurs.push("RELEVE_DATE_DEJA_PRESENT");
  const precedent = memes.filter((item) => item.date_releve < date).sort((a, b) => b.date_releve.localeCompare(a.date_releve))[0];
  const suivant = memes.filter((item) => item.date_releve > date).sort((a, b) => a.date_releve.localeCompare(b.date_releve))[0];
  if (precedent && compteur < precedent.compteur) erreurs.push("COMPTEUR_INFERIEUR_AU_PRECEDENT");
  if (suivant && compteur > suivant.compteur) erreurs.push("COMPTEUR_SUPERIEUR_AU_SUIVANT");
  return { valide: erreurs.length === 0, erreurs, precedent: precedent || null, suivant: suivant || null, km_depuis_precedent: precedent ? compteur - precedent.compteur : null };
}

export function corrigerReleveLibre(releve, nouveauCompteur, auteur, motif, releves = [], date = new Date().toISOString()) {
  if (!texte(motif)) throw new Error("MOTIF_CORRECTION_OBLIGATOIRE");
  const valeur = Number(nouveauCompteur);
  const validation = validerNouveauReleve({ ...releve, compteur: valeur }, releves);
  if (!validation.valide) throw new Error(validation.erreurs[0]);
  const historique = [...(releve.historique_corrections || [])];
  if (Number(releve.compteur) !== valeur) historique.push({ date, auteur, motif: texte(motif), champ: "compteur", ancienne_valeur: Number(releve.compteur), nouvelle_valeur: valeur });
  return { ...releve, compteur: valeur, corrige_le: date, corrige_par: auteur, historique_corrections: historique };
}

export function rappelKilometrage(vehicules = [], releves = [], commercial, aujourdHui = new Date().toISOString().slice(0, 10)) {
  const vehicule = vehiculeHabituel(vehicules, commercial, aujourdHui);
  if (!vehicule) return { afficher: false, vehicule: null, jours: null, dernier: null };
  const dernier = normaliserRelevesLibres(releves).filter((item) => String(item.vehicule_id) === String(vehicule.id) && item.date_releve <= aujourdHui).sort((a, b) => b.date_releve.localeCompare(a.date_releve))[0] || null;
  const reference = dernier?.date_releve || vehicule.date_debut || aujourdHui;
  const jours = Math.floor((new Date(`${aujourdHui}T12:00:00`) - new Date(`${reference}T12:00:00`)) / 86400000);
  return { afficher: jours > 7, vehicule, jours, dernier };
}

export function evenementsEntreReleves(actions = [], precedent, courant) {
  if (!precedent || !courant) return [];
  return actions.map((action) => {
    const type = typeInfo(action.type_deplacement);
    return { ...action, type_label: type.label, professionnel: type.professionnel };
  }).filter((action) => action.est_deplacement !== false && action.type_deplacement !== "SANS_DEPLACEMENT"
    && action.date_rdv > precedent.date_releve && action.date_rdv <= courant.date_releve
    && (!courant.commercial || !action.commercial || action.commercial === courant.commercial))
    .sort((a, b) => a.date_rdv.localeCompare(b.date_rdv));
}

export function syntheseRelevesLibres(releves = [], evenements = []) {
  const lignes = normaliserRelevesLibres(releves);
  return {
    km_total: lignes.reduce((total, ligne) => total + (ligne.km_depuis_precedent > 0 ? ligne.km_depuis_precedent : 0), 0),
    premier_compteur: lignes.length ? Math.min(...lignes.map((ligne) => ligne.compteur)) : null,
    dernier_compteur: lignes.length ? Math.max(...lignes.map((ligne) => ligne.compteur)) : null,
    deplacements_professionnels: evenements.filter((item) => item.est_deplacement !== false && item.professionnel === true).length,
    deplacements_personnels: evenements.filter((item) => item.est_deplacement !== false && item.type_deplacement === "PERSO").length
  };
}
